import { IdentificationClient } from '@frontend/identification/api';
import { Identification, UpdateIdentification } from '@frontend/identification/types';
import { updateForm, useFormValues } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const FORM_ID = 'identification-update-form';

interface ViewProps {
    formValues: UpdateIdentification;
    onCancel: (e: any) => void;
    onSubmitSuccess: (identification: Identification) => void;
    isValidIndefinitely: boolean;
    changeIsValidIndefinitely: React.Dispatch<React.SetStateAction<boolean>>;
    identification: Identification | null;
    setFormValues: (values: UpdateIdentification) => void;
}

const useIdentificationUpdate = (): ViewProps => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { accountId, identificationId } = useParams();
    const formValues = useFormValues<UpdateIdentification>(FORM_ID) ?? {};
    const [isValidIndefinitely, changeIsValidIndefinitely] = useState<boolean>(false);
    const [identification, changeIdentification] = useState<Identification | null>(null);

    const setFormValues = (values: UpdateIdentification) => {
        dispatch(updateForm({ formId: FORM_ID, value: values }));
    };

    useEffect(() => {
        if (!accountId || !identificationId) return;
        IdentificationClient.fetchIdentification(accountId, identificationId).then((res) => {
            changeIdentification(res);
            dispatch(updateForm({ formId: FORM_ID, value: { ...res, secret: undefined } }));
            changeIsValidIndefinitely(res.valid_timestamp === null);
        });
    }, [accountId]);

    const onCancel = (e: any) => {
        e.preventDefault();
        navigate(-1);
    };

    const onSubmitSuccess = (identification: Identification) => {
        navigate(-1);
    };

    return {
        formValues,
        onCancel,
        onSubmitSuccess,
        isValidIndefinitely,
        changeIsValidIndefinitely,
        identification,
        setFormValues
    };
};

export default useIdentificationUpdate;
